"use client";

import cn from "classnames";

import { ChevronDownIcon } from "@/components/icons/chevronDown.icon";
import { Text } from "@/components/text/text.component";

import {
  GetConfiguratorQueryResult,
  GetQuizResultsQueryResult,
} from "@/sanity.types";

import { ConfiguratorHeaderProduct } from "./configuratorBasePackageProduct.component";

export const ConfiguratorBasePackage = ({
  configurator,
}: ConfiguratorBasePackageProps) => {
  const renderIncludedProducts = (items?: IncludedItems) => {
    if (!items?.length) return null;
    return items.map((included, index: number) => {
      return (
        <ConfiguratorHeaderProduct
          key={included._key}
          showViewDetailsLink={!!included.showViewDetailsLink}
          productId={included.product?.id}
          title={included.title}
          subtitle={included.subtitle}
          image={included.image}
          imageAlt={included.alt}
          minimal={index >= 2}
        />
      );
    });
  };
  return (
    <section
      className="container flex flex-col gap-10 px-4"
      data-testid="configurator-base-package">
      <details
        open={true}
        className={cn(
          "group border-greyscale-background relative flex flex-col rounded-lg border-2 bg-[linear-gradient(0deg,rgba(245,246,247,0.5),rgba(245,246,247,0.5))] px-4 py-6",
        )}>
        <summary className="flex cursor-pointer items-center justify-center">
          <Text
            variant="h6"
            className="lg:headline-xs flex flex-1 justify-center px-2 text-center"
            data-testid="configurator-header-included-products-title">
            {configurator?.whatsIncludedTitle}
          </Text>
          <ChevronDownIcon className="w-6 transition-transform duration-300 group-open:rotate-180 lg:w-11" />
        </summary>
        <ul
          className="flex flex-col gap-6 px-4 py-6 lg:grid lg:grid-cols-2 lg:px-6 xl:px-12"
          data-testid="configurator-base-package-included-products-list">
          {renderIncludedProducts(configurator?.whatsIncluded)}
        </ul>
      </details>
    </section>
  );
};
type ConfiguratorPage = GetConfiguratorQueryResult | GetQuizResultsQueryResult;
type IncludedItems = NonNullable<ConfiguratorPage>["whatsIncluded"];
export type ConfiguratorBasePackageProps = {
  configurator: ConfiguratorPage;
};
